const { flex } = window;
const { React } = flex.lib;

function LandingMessage(props) {
    const { content } = props;

    return (
        content && (
            <div
                className="landing__message"
                style={{ textAlign: 'center', fontWeight: 'bold', margin: '20px 0px' }}
            >
                <div dangerouslySetInnerHTML={{ __html: content }} />
            </div>
        )
    );
}

export default LandingMessage;
